// extracted by mini-css-extract-plugin
module.exports = {"container":"no-content_container__2dX15","title":"no-content_title__3MrMp","btn":"no-content_btn__2lDTr"};